export const lockBodyScroll = (doc = document, targetWindow = window) => {
    const { documentElement } = doc;
    const previousOverflowY = documentElement.style.overflowY;
    const previousScrollbarGutter = documentElement.style.scrollbarGutter;
    const previousBackgroundColor = documentElement.style.backgroundColor;
    const previousScrollbarWidth = documentElement.style.getPropertyValue("--smm-auth-scrollbar-width");
    const scrollbarWidth = Math.max(0, targetWindow.innerWidth - documentElement.clientWidth);
    documentElement.style.overflowY = "hidden";
    if (scrollbarWidth > 0 && documentElement.clientWidth > 768) {
        documentElement.style.scrollbarGutter = "stable";
        documentElement.style.backgroundColor = "rgba(12, 16, 25, 0.48)";
        documentElement.style.setProperty("--smm-auth-scrollbar-width", `${scrollbarWidth}px`);
    }
    return () => {
        documentElement.style.overflowY = previousOverflowY;
        documentElement.style.scrollbarGutter = previousScrollbarGutter;
        documentElement.style.backgroundColor = previousBackgroundColor;
        if (previousScrollbarWidth) {
            documentElement.style.setProperty("--smm-auth-scrollbar-width", previousScrollbarWidth);
        }
        else {
            documentElement.style.removeProperty("--smm-auth-scrollbar-width");
        }
    };
};
//# sourceMappingURL=scroll-lock.js.map